import moment from "moment";
import messagesService from "../services/messages.service";

export const getConversationId = async (userId: string, name: string) => {
  if (!userId) {
    throw new Error("User id required");
  }
  if (!name) {
    throw new Error("User name required");
  }
  const getExistingConvId = await messagesService.checkConversation(userId);

  if (!getExistingConvId) {
    // const createConv = await messagesService.createConversation(userId, name);
    return null;
  }

  return getExistingConvId;
};

export const getNewConversationId = async (
  userId: string,
  name: string,
  img: string,
  loggedInUserImg: string
) => {
  const getExistingConvId = await messagesService.checkConversation(userId);
  if (!getExistingConvId) {
    const createConv = await messagesService.createConversation(
      userId,
      name,
      img,
      loggedInUserImg
    );
    return createConv;
  }
  return getExistingConvId;
};

export function getPaginationCountText(
  currentPage: number,
  totalPages: number,
  totalRecords: number,
  perPage: number
) {
  let startIndex, endIndex;

  // Calculate the starting index
  startIndex = (currentPage - 1) * perPage + 1;

  // Check if it's the last page
  if (currentPage === totalPages) {
    endIndex = totalRecords;
  } else {
    // Calculate the ending index for non-last pages
    endIndex = Math.min(currentPage * perPage, totalRecords);
  }

  // Calculate the total number of records being displayed
  const count = `${startIndex}-${endIndex}`;

  // Return the pagination count string
  return `Showing ${count} of ${totalRecords}`;
}

export function formatMessageTime(timestamp: any) {
  const now = moment();
  const messageTime = moment(timestamp);

  if (now.diff(messageTime, "hours") < 24) {
    return messageTime.format("hh:mm A"); // Time within 24 hours
  } else if (now.diff(messageTime, "days") === 1) {
    return "Yesterday"; // Exactly one day ago
  } else {
    return messageTime.format("DD/MM/YYYY"); // Older dates
  }
}
